import React, { useEffect, useState } from "react";
import "./style.scss";
import { getKnowledgeStackPodcastDetail } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

const Podcastdetail = (props) => {
  const {
    getKnowledgeStackPodcastDetail,
    podcastDetailData,
    suggestedUrl,
    typeData,
    overviewTab,
  } = props;

  const type = typeData;
  const sugUrl = suggestedUrl;
  const [podcastDetaillist, setPodcastDetaillist] = useState();
  const [defaultAudio, setDefaultAudio] = useState([]);
  const [metaData, setMetaData] = useState();

  const handleChangeAudio = async (e, item) => {
    setDefaultAudio(item);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getKnowledgeStackPodcastDetail(sugUrl);
  }, [suggestedUrl]);

  useEffect(() => {
    if (
      podcastDetailData &&
      podcastDetailData.podcast &&
      podcastDetailData.podcast[0]
    ) {
      setPodcastDetaillist(podcastDetailData.podcast[0]);
    }

    if (
      podcastDetailData &&
      podcastDetailData.podcast &&
      podcastDetailData.podcast[0] &&
      podcastDetailData.podcast[0].episodes &&
      podcastDetailData.podcast[0].episodes[0]
    ) {
      setDefaultAudio(podcastDetailData.podcast[0].episodes[0]);
    }

    if (
      podcastDetailData &&
      podcastDetailData.podcast &&
      podcastDetailData.podcast[0] &&
      podcastDetailData.podcast[0].meta
    ) {
      setMetaData(podcastDetailData.podcast[0].meta);
    }
  }, [podcastDetailData]);

  return (
    <>
      <div className="wrapper">
        {metaData ? (
          <Helmet>
            <title>{metaData && metaData.title ? metaData.title : ""}</title>
            <meta
              name="description"
              content={
                metaData && metaData.description ? metaData.description : ""
              }
            />
            <meta
              name="keywords"
              content={metaData && metaData.keywords ? metaData.keywords : ""}
            />
            <meta
              property="og:title"
              content={metaData && metaData.og_title ? metaData.og_title : ""}
            />
            <meta
              property="og:description"
              content={
                metaData && metaData.og_description
                  ? metaData.og_description
                  : ""
              }
            />
            <meta
              property="og:image"
              content={metaData && metaData.og_image ? metaData.og_image : ""}
            />
            <meta
              property="og:url"
              content={metaData && metaData.og_url ? metaData.og_url : ""}
            />
          </Helmet>
        ) : (
          ""
        )}
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex">
              <h1 className="me-auto">
                <span>Podcast</span>
              </h1>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/knowledge-stack">Knowledge Stack</a>
                  </li>
                  <li
                    className="breadcrumb-item active breadcolor"
                    aria-current="page"
                  >
                    <a href="/knowledge-stack/interactive-media/podcasts">Podcast</a>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>

        <section>
          <div className="container mt-5 mb-5 podcastdetail">
            <div className="bluediv">
              <div className="reddiv">
                <div className="podcastdiv row">
                  <div className="col-md-12">
                    <h2 className="text-center mb-5">Podcast Series</h2>
                  </div>
                  <div className="col-md-9 audiodiv p-4 mx-auto">
                    <div className="row">
                      <div className="col-md-3 d-flex justify-content-center align-items-center">
                        <img
                          src={
                            defaultAudio.thumbnail ? defaultAudio.thumbnail : ""
                          }
                          className="img-fluid"
                        />
                      </div>
                      <div className="col-md-9">
                        <h3 className="bluecolour">
                          {defaultAudio.title ? defaultAudio.title : ""}
                        </h3>
                        <p className="my-3">
                          {defaultAudio.description
                            ? defaultAudio.description
                            : ""}
                        </p>
                      </div>
                      <div className="col-md-12 mt-3">
                        <audio
                          preload="auto"
                          src={defaultAudio && defaultAudio.file}
                          class="w-100"
                          controls
                        >
                          <source src={defaultAudio && defaultAudio.file} />
                        </audio>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="podcastlist">
              <div className="row">
                {podcastDetaillist &&
                  podcastDetaillist.episodes &&
                  podcastDetaillist.episodes.length > 0 &&
                  podcastDetaillist.episodes.map((item, index) => (
                    <div className="col-md-6 mb-4">
                      {item.title != defaultAudio.title ? (
                        <div className="card">
                          <div className="p-3 row">
                            <div className="col-md-4 d-flex justify-content-md-center align-items-center">
                              <a
                                href="javascript:void(0)"
                                onClick={(e) => handleChangeAudio(e, item)}
                              >
                                <img
                                  src={item.thumbnail ? item.thumbnail : ""}
                                  className="img-fluid"
                                />
                              </a>
                            </div>
                            <div className="col-md-8">
                              <a
                                href="javascript:void(0)"
                                onClick={(e) => handleChangeAudio(e, item)}
                              >
                                <h3 className="bluecolour">
                                  {item.title ? item.title : ""}
                                </h3>
                              </a>
                              <p className="my-3">
                                {item.description ? item.description : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="card cardopacity">
                          <div className="p-3 row">
                            <div className="col-md-4 d-flex justify-content-md-center align-items-center">
                              <img
                                src={item.thumbnail ? item.thumbnail : ""}
                                className="img-fluid"
                              />
                            </div>
                            <div className="col-md-8">
                              <h3 className="bluecolour">
                                {item.title ? item.title : ""}
                              </h3>
                              <p className="my-3">
                                {item.description ? item.description : ""}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}

              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  podcastDetailData: state.KnowledgeStack.podcastDetailPageData,
});

const mapDispatchToProps = (dispatch) => ({
  getKnowledgeStackPodcastDetail: bindActionCreators(
    getKnowledgeStackPodcastDetail,
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Podcastdetail);
